export const schedulePaymentsConstants = {
  recurringFrequencyOptions: [
    { value: "ONETIME", label: "One-time", selected: "selected" },
    { value: "DAILY", label: "Daily" },
    { value: "WEEKLY", label: "Weekly" },
    { value: "MONTHLY", label: "Monthly" },
    { value: "QUARTERLY", label: "Every 3 Months" },
    { value: "HALF_YEARLY", label: "Every 6 Months" },
    { value: "ANNUALLY", label: "Annually" },
    { value: "N_NUMBER_OF_DAYS", label: "N number of days" },
  ],

  RECURRING_FREQUENCY_ONETIME: "ONETIME",
  RECURRING_FREQUENCY_DAILY: "DAILY",
  RECURRING_FREQUENCY_WEEKLY: "WEEKLY",
  RECURRING_FREQUENCY_MONTHLY: "MONTHLY",
  RECURRING_FREQUENCY_QUARTERLY: "QUARTERLY",
  RECURRING_FREQUENCY_HALF_YEARLY: "HALF_YEARLY",
  RECURRING_FREQUENCY_ANNUALLY: "ANNUALLY",
  RECURRING_FREQUENCY_N_NUMBER_OF_DAYS: "N_NUMBER_OF_DAYS",

  SCHEDULE_PAYMENTS_LIST_REQUEST: "SCHEDULE_PAYMENTS_LIST_REQUEST",
  SCHEDULE_PAYMENTS_LIST_COMPLETE: "SCHEDULE_PAYMENTS_LIST_COMPLETE",
  SCHEDULE_PAYMENTS_LIST_ERROR: "SCHEDULE_PAYMENTS_LIST_ERROR",

  SCHEDULE_PAYMENTS_DETAIL_VIEW_REQUEST:
    "SCHEDULE_PAYMENTS_DETAIL_VIEW_REQUEST",
  SCHEDULE_PAYMENTS_DETAIL_VIEW_COMPLETE:
    "SCHEDULE_PAYMENTS_DETAIL_VIEW_COMPLETE",
  SCHEDULE_PAYMENTS_DETAIL_VIEW_ERROR: "SCHEDULE_PAYMENTS_DETAIL_VIEW_ERROR",

  SET_ACTIVE_VIEW: "SET_ACTIVE_VIEW",

  ACTIVE_VIEW_SCHEDULE_PAYMENT_SUMMARY: "SCHEDULE_PAYMENT_SUMMARY",
  ACTIVE_VIEW_SCHEDULE_PAYMENT_ITERATION_DETAIL:
    "SCHEDULE_PAYMENT_ITERATION_DETAIL",
  ACTIVE_VIEW_SCHEDULE_PAYMENT_SUCCESS: "SCHEDULE_PAYMENT_SUCCESS",
  ACTIVE_VIEW_SCHEDULE_PAYMENT_STOP_SUCCESS: "SCHEDULE_PAYMENT_STOP_SUCCESS",
  ACTIVE_VIEW_SELECT_SCHEDULE_PAYMENT_TYPE: "SELECT_SCHEDULE_PAYMENT_TYPE",
  ACTIVE_VIEW_SCHEDULE_PAYMENT_ITERATION_STOP:
    "SCHEDULE_PAYMENT_ITERATION_STOP",

  TAB_TYPE_ALL: "ALL",
  TAB_TYPE_FUND_TRANSFER: "TRANSFER",
  TAB_TYPE_BILL_PAYMENT: "BILL_PAYMENT",
  TAB_TYPE_CARD_SETTLEMENT: "CC_PAYMENT",

  SCHEDULE_DETAIL_TAB_UPCOMING_SCHEDULES: "UPCOMING_SCHEDULES",
  SCHEDULE_DETAIL_TAB_PAST_SCHEDULES: "PAST_SCHEDULES",

  SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED: "COMPLETED",
  SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE: "ACTIVE",
  SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED: "STOPPED",
  SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_SUCCESS: "SUCCESS",
  SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_FAIL: "FAIL",

  SET_SCHEDULE_PAYMENTS_DETAILS: "SET_SCHEDULE_PAYMENTS_DETAILS",

  CHANGE_ITERATION_STATUS_REQUEST: "CHANGE_ITERATION_STATUS_REQUEST",
  CHANGE_ITERATION_STATUS_COMPLETE: "CHANGE_ITERATION_STATUS_COMPLETE",
  CHANGE_ITERATION_STATUS_ERROR: "CHANGE_ITERATION_STATUS_ERROR",

  SCHEDULE_ITERATION_LIST_REQUEST: "SCHEDULE_ITERATION_LIST_REQUEST",
  SCHEDULE_ITERATION_LIST_COMPLETE: "SCHEDULE_ITERATION_LIST_COMPLETE",
  SCHEDULE_ITERATION_LIST_ERROR: "SCHEDULE_ITERATION_LIST_ERROR",

  STOP_SCHEDULE_PAYMENT_REQUEST: "STOP_SCHEDULE_PAYMENT_REQUEST",
  STOP_SCHEDULE_PAYMENT_COMPLETE: "STOP_SCHEDULE_PAYMENT_COMPLETE",
  STOP_SCHEDULE_PAYMENT_ERROR: "STOP_SCHEDULE_PAYMENT_ERROR",
  CLEAR_STOP_SCHEDULE_PAYMENT_CLOSE_MODAL:
    "CLEAR_STOP_SCHEDULE_PAYMENT_CLOSE_MODAL",

  SET_SELECTED_SCHEDULE_PAYMENTS_ITERATION_DETAILS:
    "SET_SELECTED_SCHEDULE_PAYMENTS_ITERATION_DETAILS",

  SCHEDULED_PAYMENT_TYPE_BILL: "BILL_PAYMENT",
  SCHEDULED_PAYMENT_TYPE_TRANSFER: "TRANSFER",
  SCHEDULED_PAYMENT_TYPE_CARD_SETTLEMENT: "CC_PAYMENT",

  NAVIGATE_FROM_SCHEDULE_PAYMENTS: "NAVIGATE_FROM_SCHEDULE_PAYMENTS",

  SET_NAVIGATE_FROM: "SET_NAVIGATE_FROM",

  LIST_STATUS_ALL: "ALL",
  LIST_STATUS_ACTIVE: "ACTIVE",

  CLEAR_STATE: "CLEAR_STATE",
  CLEAR_NAVIGATE_FROM: "CLEAR_NAVIGATE_FROM",

  CLEAR_CHANGE_ITERATION_STATUS_SUCCESS:
    "CLEAR_CHANGE_ITERATION_STATUS_SUCCESS",

  SET_ACTIVE_LIST_TYPE: "SET_ACTIVE_LIST_TYPE",
  SET_FILTER_PAYMENT_STATUS: "SET_FILTER_PAYMENT_STATUS",
  SET_SCHEDULE_DETAIL_ACTIVE_TAB: "SET_SCHEDULE_DETAIL_ACTIVE_TAB",
};
